import React, { useState, useRef, useEffect } from 'react';
import { BsThreeDotsVertical } from 'react-icons/bs';
import { Header, HeaderTitle, HeaderIconButton } from '../../styles/ChatStyles';
import Menu from './Menu';
import SocketConnectionIndicator from '../SocketConnectionIndicator';

const ChatHeader = ({ config, isTyping, onRefreshConversation, socketConnected, socketConnecting }) => {
  const [showMenu, setShowMenu] = useState(false);
  const menuRef = useRef(null);
  const buttonRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        menuRef.current && 
        !menuRef.current.contains(event.target) &&
        !buttonRef.current.contains(event.target)
      ) {
        setShowMenu(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleMenuClick = () => {
    setShowMenu(!showMenu);
  };

  const handleRefreshConversation = () => {
    setShowMenu(false);
    onRefreshConversation();
  };

  return (
    <Header>
      <HeaderTitle>
        <img src={config.chatbot_logo_url} alt="Bot Avatar" />
        <div>
          <h2>{config.chat_title}</h2>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <span>{isTyping ? 'Typing...' : 'Online'}</span>
            <SocketConnectionIndicator 
              connected={socketConnected} 
              connecting={socketConnecting}
            />
          </div>
        </div>
      </HeaderTitle>
      <div style={{ position: 'relative' }}>
        <HeaderIconButton 
          ref={buttonRef}
          onClick={handleMenuClick} 
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <BsThreeDotsVertical size={20} />
        </HeaderIconButton>
        {showMenu && (
          <div ref={menuRef}>
            <Menu onRefreshConversation={handleRefreshConversation} />
          </div>
        )}
      </div>
    </Header>
  );
};

export default ChatHeader;